import FormattedMessage from 'I18n/components/FormattedMessage';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalHeadingI18n() {
  const {
    noApprovalData,
    isCancelled,
    isApproved,
    isPending,
    isRejected,
    isUserStepPending
  } = useApprovalConditions();
  if (noApprovalData) {
    return null;
  }
  if (isCancelled) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalHeading.cancelled"
    });
  }
  if (isApproved) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalHeading.approved"
    });
  }
  if (isPending && isUserStepPending) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalHeading.pendingYourApproval"
    });
  }
  if (isPending) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalHeading.pending"
    });
  }
  if (isRejected) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalHeading.rejected"
    });
  }
  return null;
}